module.exports = __webpack_public_path__ + "static/img/tu.3b30677.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/service/tu.png
// module id = WrQY
// module chunks = 1